/**
 * The marks a room is known by.
 *
 * A channel is a hash and a closed channel a padlock. Both were drawn three
 * times over — once in the sidebar, once in the channel browser, once in the
 * composer — and the overview had a fourth version made of box-drawing
 * characters, which rendered as a heavy black square on iPadOS. One drawing
 * each, sized by the caller, so a room carries the same mark wherever it is
 * listed.
 */

import type { ReactElement } from 'react'

export interface GlyphIconProps {
  /** Edge length in pixels. The defaults suit a list row. */
  size?: number
}

export function HashIcon({ size = 14 }: GlyphIconProps): ReactElement {
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M6.5 2.6 5 13.4M11.4 2.6 9.9 13.4M2.7 6h10.7M2.2 10.1h10.7"
        stroke="currentColor"
        strokeWidth="1.45"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function LockIcon({ size = 13 }: GlyphIconProps): ReactElement {
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3.5" y="7" width="9" height="6.5" rx="2" stroke="currentColor" strokeWidth="1.35" />
      <path d="M5.5 7V5.2a2.5 2.5 0 0 1 5 0V7" stroke="currentColor" strokeWidth="1.35" />
    </svg>
  )
}
